import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface SettingsSectionProps {
  title: string;
  /** Explains the control; sits between the title and the control. */
  help?: string;
  /** Longer guidance that reads better after the control (e.g. examples). */
  footerHelp?: string;
  className?: string;
  children: ReactNode;
}

/** One titled block of the dialog body: title, help, control, footer help. */
export const SettingsSection = ({
  title,
  help,
  footerHelp,
  className,
  children,
}: SettingsSectionProps) => (
  <section className={cn("flex flex-col gap-2", className)}>
    <h3 className="text-sm font-medium">{title}</h3>
    {help && <p className="text-xs text-muted-foreground">{help}</p>}
    {children}
    {footerHelp && <p className="text-xs text-muted-foreground">{footerHelp}</p>}
  </section>
);
